import { render } from "./InstagramFeed.vue?vue&type=template&id=6cc553b9&scoped=true"
import script from "./InstagramFeed.vue?vue&type=script&lang=js"
export * from "./InstagramFeed.vue?vue&type=script&lang=js"

import "./InstagramFeed.vue?vue&type=style&index=0&id=6cc553b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc553b9"]])

export default __exports__